import ScenariosView from './Scenarios.view';
export * from './Scenarios.view';

export const Scenarios = (props) => ScenariosView(props);

export default Scenarios;

